import React, { useState, useEffect } from 'react'
import { Link, Redirect, useParams } from "react-router-dom"
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { host, Host } from '../App';
import Axios from 'axios'
import '../Responsive.css'
import { Chair } from '@mui/icons-material';

function Woodshop_Inventory() {
  var [del, setdel] = useState(1);
  var [SheetId, setSheetId] = useState({});
  var [Date1, setDate1] = useState(new Date());
  var [poNo, setpoNo] = useState([]);
  var [CutStartDate, setCutStartDate] = useState('2025-01-01');
  var [CutEndDate, setCutEndDate] = useState(Date1.toISOString().slice(0, 10));
  var [ItemNo, setItemNo] = useState("");
  var [Operator, setOperator] = useState("");
  var [LotNo, setLotNo] = useState({});
  var [ChairPartType, setChairPartType] = useState({});
  var [partNo, setpartNo] = useState({});
  const [data, setData] = useState([]);
  const [Issueddata, setIssuedData] = useState([]);
  const [Alldata, setAlldata] = useState([]);
  var token = (window.localStorage.getItem("acessToken"));
  const [employees, setEmployees] = useState([]);
  const user = JSON.parse(window.localStorage.getItem("Name"));
  const [isLoading, setIsLoading] = useState(false);
  const [DetailedView, setDetailedView] = useState(true);
  const [IssuedParts, setIssuedParts] = useState(true);
  const queryParams = {
    Sheet_Id: JSON.stringify(SheetId),
    Item_No: JSON.stringify(ItemNo),
    CutDate1: CutStartDate,
    CutDate2: CutEndDate,
    Operator: JSON.stringify(Operator),
    Lot_No: JSON.stringify(LotNo),
    Chair_Part_Type: JSON.stringify(ChairPartType),
    token: token,
    Part_No: JSON.stringify(partNo)
  };
  var length = 0;
  //var token = sessionStorage.getItem("token");
  const toggle_Detailedview = () => {
    setDetailedView(!DetailedView);

  };
  const toggle_IssuedParts = () => {
    setIssuedParts(!IssuedParts);
  };

  useEffect(() => {
    Axios.get(`https://` + Host + `/api/get/pono/${token}`).then((data) => {
      setpoNo(data.data)
    });
  }, [])

  useEffect(() => {
    Axios.get(`https://` + host + `/woodshop/Woodshop_Inventory`, { params: queryParams })
      .then((data) => {
        setData(data.data);
      })
  }, [SheetId, CutStartDate, CutEndDate, ItemNo, Operator, LotNo, ChairPartType, partNo, del]);

  useEffect(() => {
    Axios.get(`https://` + host + `/woodshop/all/Woodshop_Inventory`, { params: queryParams })
      .then((data) => {
        setAlldata(data.data);
      })
  }, [SheetId, CutStartDate, CutEndDate, ItemNo, Operator, LotNo, ChairPartType, partNo, del]);

  useEffect(() => {
    Axios.get(`https://` + host + `/woodshop/Issued_Inventory`, { params: queryParams })
      .then((data) => {
        setIssuedData(data.data);
      })
  }, [SheetId, CutStartDate, CutEndDate, ItemNo, Operator, LotNo, ChairPartType, partNo, del]);




  const [changedRows, setChangedRows] = useState(new Set());

  const Delete = (Po_No, Item_No, Receiving_Date) => {
    const queryParams = {
      token: token,
      Po_No: Po_No,
      Item_No: Item_No,
      Receiving_Date: Receiving_Date
    };

    Axios.delete(`https://` + host + `/api/History_ReceivedRawMaterial/Delete`, { params: queryParams }).then((response) => {
      if (response.status === 200) {
        toast.success(response.data.message, {
          autoClose: 1000,
          position: toast.POSITION.TOP_RIGHT,
          style: { fontSize: '24px', borderRadius: '10px', color: 'red' },
        });
      }
    })
      .catch(function (error) {
        console.log(error.response);
      });
  };
  useEffect(() => {
    Axios.get(`https://` + host + `/api/employees_all/${token}`).then((data) => {
      setEmployees(data.data);
    });
  }, []);

  const print = () => {
    console.log(data);
  }
  const submitdata = () => {
    const filteredData = [];
    data.forEach(item => {
      if (
        item.newQty &&
        item.Po_No
      ) {
        const newData = [
          item.Sheet_Id,
          item.Item_No,
          item.Lot_No,
          item.Chair_Part_Type,
          item.Part_No,
          item.Dimensions,
          item.QTY,
          item.Cut_Date,
          item.Operator,
          item.Status,
          item.Remarks,
          item.newQty,
          item.Po_No,
          user
        ];

        filteredData.push(newData);
      }
      length = filteredData.length;
    });
    console.log(filteredData);
    setTimeout(() => {
      Axios.post(`https://` + host + `/woodshop/Issued_Parts`, { filteredData })
        .then((response) => {
          if (response.status === 200) {
            const numberInputs = document.querySelectorAll('input[type="number"]');
            numberInputs.forEach(input => {
              input.value = '';
            });
            toast.success(response.data.message, {
              autoClose: 3000,
              position: toast.POSITION.TOP_RIGHT,
              style: { fontSize: '24px', borderRadius: '10px' },
            });
            setdel(del = del + 1);
          }
        })
        .catch(error => {
          window.alert("Error Occured")
          setIsLoading(false);
        });
    }, 2000);

    // window.location.reload(false);

  }
  return (
    <div className="MainPage_data">
      <div class="Container">

        <ToastContainer />
        <div className="row">
          {/* Sheet ID Filter */}
          <div className="col">
            <input
              type="text"
              className="form-control form-rounded"
              placeholder="Sheet ID"
              list="SheetIdList"
              onChange={(e) => setSheetId(e.target.value)}
            />
            <datalist id="SheetIdList">
              <option></option>
              {data
                .map((x) => x.Sheet_Id)                           // grab the lot numbers
                .filter((lot, i, all) => all.indexOf(lot) === i) // keep only first occurrence
                .map((lot) => (
                  <option key={lot} value={lot}>
                    {lot}
                  </option>
                ))
              }
            </datalist>
          </div>

          {/* Item No Filter */}
          <div className="col">
            <input
              type="text"
              className="form-control form-rounded"
              placeholder="Item No"
              list="ItemNoList"
              onChange={(e) => setItemNo(e.target.value)}

            />
            <datalist id="ItemNoList">
              <option></option>
              {data
                .map((x) => x.Item_No)                           // grab the lot numbers
                .filter((lot, i, all) => all.indexOf(lot) === i) // keep only first occurrence
                .map((lot) => (
                  <option key={lot} value={lot}>
                    {lot}
                  </option>
                ))
              }
            </datalist>
          </div>

          {/* Lot No Filter */}
          <div className="col">
            <input
              type="text"
              className="form-control form-rounded"
              placeholder="Lot No"
              list="LotNoList"
              onChange={(e) => setLotNo(e.target.value)}

            />
            <datalist id="LotNoList">
              <option></option>
              {data
                .map((x) => x.Lot_No)                           // grab the lot numbers
                .filter((lot, i, all) => all.indexOf(lot) === i) // keep only first occurrence
                .map((lot) => (
                  <option key={lot} value={lot}>
                    {lot}
                  </option>
                ))
              }
            </datalist>
          </div>

          {/* Chair Part Type Filter */}
          <div className="col">
            <input
              type="text"
              className="form-control form-rounded"
              placeholder="Chair Part Type"
              list="ChairPartTypeList"
              onChange={(e) => setChairPartType(e.target.value)}

            />
            <datalist id="ChairPartTypeList">
              <option></option>
              {data
                .map((x) => x.Chair_Part_Type)                           // grab the lot numbers
                .filter((lot, i, all) => all.indexOf(lot) === i) // keep only first occurrence
                .map((lot) => (
                  <option key={lot} value={lot}>
                    {lot}
                  </option>
                ))
              }


            </datalist>
          </div>

          {/* Part No Filter */}
          <div className="col">
            <div className="row">
              <input
                type="text"
                className="form-control form-rounded"
                placeholder="Part No"
                list="PartNoList"
                onChange={(e) => setpartNo(e.target.value)}

              />
              <datalist id="PartNoList">
                <option></option>
                {data
                  .map((x) => x.Part_No)                           // grab the lot numbers
                  .filter((lot, i, all) => all.indexOf(lot) === i) // keep only first occurrence
                  .map((lot) => (
                    <option key={lot} value={lot}>
                      {lot}
                    </option>
                  ))
                }
              </datalist>
            </div>
            <div className="row">
              <button class="btn btn-primary" onClick={toggle_IssuedParts} >Issued Parts</button>
            </div>
          </div>

          {/* Cut Date Filters */}
          <div className="col">
            <div className="row">
              <input
                type="date"
                className="form-control form-rounded"
                placeholder="Cut Start Date"
                Value={CutStartDate}
                onChange={(e) => setCutStartDate(e.target.value)}
              />
            </div>
            <div className="row">
              <input
                type="date"
                className="form-control form-rounded"
                placeholder="Cut End Date"
                Value={CutEndDate}
                onChange={(e) => setCutEndDate(e.target.value)}
              />
            </div>
          </div>
          {/* Operator Filter */}
          <div className="col">
            <div className="row">
              <input
                type="text"
                className="form-control form-rounded"
                placeholder="Operator"
                list="OperatorList"
                onChange={(e) => setOperator(e.target.value)}

              />
              <datalist id="OperatorList">
                <option value="" />
                {Array.from(new Set(data.map(x => x.Operator))).map(op => (
                  <option key={op} value={op}>
                    {op}
                  </option>
                ))}
              </datalist>

            </div>
            <div className="row">
              {IssuedParts ?
                <button class="btn btn-primary" onClick={toggle_Detailedview} >Detailed View</button> : null}
            </div>

          </div>
        </div>

        <br></br>
        <br></br>
        <div >
          {/* Finsihed parts - user view */}
          {DetailedView && IssuedParts ? (

            <div>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Sheet ID</th>
                    <th>Item No</th>
                    <th>Lot No</th>
                    <th>Chair Part Type</th>
                    <th>Part No</th>
                    <th>Dimensions</th>
                    <th>QTY</th>
                    <th>Cut Date</th>
                    <th>Operator</th>
                    <th>Status</th>
                    <th>Remarks</th>
                    <th>QTY</th>
                    <th>PO NO</th>
                    <th>Operator</th>
                    <th>Submit</th>
                  </tr>
                </thead>
                {data
                  .filter(val => (val.QTY) > 0)
                  .map((val, index) => (
                    <tbody key={index}>
                      <tr key={`${val.Id}`} >
                        <td >{val.Sheet_Id}</td>
                        <td >{val.Item_No}</td>
                        <td >{val.Lot_No}</td>
                        <td >{val.Chair_Part_Type}</td>
                        <td >{val.Part_No}</td>
                        <td >{val.Dimensions}</td>
                        <td >{val.QTY}</td>
                        <td >{val.Cut_Date ? val.Cut_Date.slice(0, 10) : ""}</td>
                        <td >{val.Operator}</td>
                        <td >{val.Status}</td>
                        <td >{val.Remarks}</td>
                        <td>
                          <input
                            type="number"
                            className={`form-control ${data[index].newQty > val.QTY ? 'is-invalid' : ''
                              }`}
                            placeholder={`0 – ${val.QTY}`}
                            min={0}
                            max={val.QTY}
                            // make this a controlled input
                            value={data[index].newQty ?? ''}
                            onChange={(e) => {
                              let v = parseInt(e.target.value, 10) || 0;
                              if (v > val.QTY) v = val.QTY;
                              const newData = [...data];
                              newData[index].newQty = v;
                              setData(newData);
                            }}
                          />
                        </td>

                        <td>
                          <input
                            type="text"
                            className="form-control"
                            onChange={(e) => {
                              const newData = [...data];
                              newData[index].Po_No = e.target.value;
                              setData(newData);
                            }}
                            placeholder="Enter PO No"
                            list='PO'
                          />
                          <datalist id="PO">
                            <option></option>
                            {poNo.map(x => {
                              return <option>{x.PO_NO}</option>
                            })}
                          </datalist>
                        </td>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            value-={user}
                            onChange={(e) => {
                              const newData = [...data];
                              newData[index].newUser = e.target.value;
                              setData(newData);
                            }}
                            list='employee'
                          />
                          <datalist id="employee">
                            <option></option>
                            {employees.map(x => {
                              return <option key={x.Emp_ID}>{x.Name}</option>
                            })}
                          </datalist>
                        </td>
                        <td>
                          <button className='btn btn-primary' onClick={submitdata}>Submit</button>
                        </td>
                      </tr>
                    </tbody>
                  ))}
              </table>
            </div>
          ) : DetailedView || !DetailedView && !IssuedParts ? (
            <div>
              {/* ISSUED parts*/}
              <h2>ISSUED PARTS</h2><br />
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Sheet ID</th>
                    <th>Item No</th>
                    <th>Lot No</th>
                    <th>Chair Part Type</th>
                    <th>Part No</th>
                    <th>Dimensions</th>
                    <th>QTY</th>
                    <th>Cut Date</th>
                    <th>Operator</th>
                    <th>Status</th>
                    <th>Remarks</th>
                    <th>Entered By</th>
                  </tr>
                </thead>
                {Issueddata.map((val, index) => (
                  <tbody key={index}>
                    <tr key={`${val.Id}`} >
                      <td >{val.Sheet_Id}</td>
                      <td >{val.Item_No}</td>
                      <td >{val.Lot_No}</td>
                      <td >{val.Chair_Part_Type}</td>
                      <td >{val.Part_No}</td>
                      <td >{val.Dimensions}</td>
                      <td >{val.Issued_QTY}</td>
                      <td >{val.Cut_Date ? val.Cut_Date.slice(0, 10) : ""}</td>
                      <td >{val.Operator}</td>
                      <td >{val.Status}</td>
                      <td >{val.Remarks}</td>
                      <td >{val.User}</td>
                    </tr>
                  </tbody>
                ))}
              </table></div>
          ) : !DetailedView && IssuedParts ? (
            <div>
              {/* Finished parts Detailed view*/}

              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Sheet ID</th>
                    <th>Item No</th>
                    <th>Lot No</th>
                    <th>Chair Part Type</th>
                    <th>Part No</th>
                    <th>Dimensions</th>
                    <th>QTY</th>
                    <th>Cut Date</th>
                    <th>Operator</th>
                    <th>Status</th>
                    <th>Remarks</th>
                    <th>Entered By</th>
                  </tr>
                </thead>
                {Alldata.map((val, index) => (
                  <tbody key={index}>
                    <tr key={`${val.Id}`} >
                      <td >{val.Sheet_Id}</td>
                      <td >{val.Item_No}</td>
                      <td >{val.Lot_No}</td>
                      <td >{val.Chair_Part_Type}</td>
                      <td >{val.Part_No}</td>
                      <td >{val.Dimensions}</td>
                      <td >{val.QTY}</td>
                      <td >{val.Cut_Date ? val.Cut_Date.slice(0, 10) : ""}</td>
                      <td >{val.Operator}</td>
                      <td >{val.Status}</td>
                      <td >{val.Remarks}</td>
                      <td >{val.User}</td>
                    </tr>
                  </tbody>
                ))}
              </table></div>
          ) : null}
        </div>
      </div >
      {isLoading ?
        <div className='overlay'>
          <div className="loading-container">
            <div className="loading-dots">
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
            </div>
            <p className='loading'>Submitting</p>
          </div>

        </div> : null}
    </div >
  )
}

export default Woodshop_Inventory;